
export default [
    {
        path: 'system',
        name: 'usercenter-messages-system',
        meta: {
            title: '消息列表-个人中心'
        },
        component: () => import("@/pages/usercenter/messages/System"),
    },
    {
        path: 'push',
        name: 'usercenter-messages-push',
        meta: {
            title: '消息列表-个人中心'
        },
        component: () => import("@/pages/usercenter/messages/Push"),
    },
    {
        path: 'mine',
        name: 'usercenter-messages-mine',
        meta: {
            title: '消息列表-个人中心'
        },
        component: () => import("@/pages/usercenter/messages/Mine"),
    },
];


// WEBPACK FOOTER //
// ./src/router/usercenter/messages/index.js